var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsView = function SvgInterfaceActionsView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C4 4 1 12 1 12s3 8 11 8 11-8 11-8-3-8-11-8Zm0 2c5.276 0 7.945 4.267 8.809 5.996C19.944 13.713 17.255 18 12 18c-5.276 0-7.945-4.267-8.809-5.996C4.057 10.287 6.745 6 12 6Zm0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 .001 3.999A2 2 0 0 1 12 10Z"
  })));
};
export default SvgInterfaceActionsView;